import { Modal, Table } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FlapperSpinner } from "react-spinners-kit";
import "../../../App.css";
import { DoubleCheck, goBack } from "../../../core/assets/icons";
import { ErrorToast } from "../../componets/toast";
import { useMdaDetails, useMdaActivate } from "../auth/hooks/useUser";
import { Layout } from "./layout";
import { FormatMoney } from "../../../core/helpers";

const MdaDetails = () => {
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [serviceId, setServiceId] = useState<string>("");

  const {
    data: detailsData,
    mutate: detailsMutate,
    isLoading,
  } = useMdaDetails();

  const {
    data: activateData,
    mutate: activateMutate,
    isLoading: activateLoading,
  } = useMdaActivate();

  useEffect(() => {
    const currentPath = window.location.pathname;
    const lastSlashIndex = currentPath.lastIndexOf("/");

    if (lastSlashIndex !== -1) {
      const lastSegment = currentPath.substring(lastSlashIndex + 1);

      setServiceId(lastSegment);

      console.log(lastSegment);



      detailsMutate(lastSegment, {
        onSuccess: (response: any) => {
          if (response.length === 0) {
            navigate("/admin/mda-directory");
          } else {
            //  console.log("dejje\\n", response);
            // setMdaData(response);
          }
        },
        onError: (err: any) => {
          ErrorToast(err);
          navigate("/admin/mda-directory");
        },
      });
    } else {
      navigate("/admin/mda-directory");
    }
  }, []);

  const navigate = useNavigate();

  const dataSource: any[] = [];

  const columns = [
    {
      title: "User Details",
      width: "760",
      children: [
        {
          title: "First Name",
          dataIndex: "firstName",
          key: "firstName",
          width: "66",
        },
        {
          title: "Last Name",
          dataIndex: "lastName",
          key: "lastName",
          width: "66",
        },
        {
          title: "Phone Number",
          dataIndex: "phoneNumber",
          key: "phoneNumber",
          width: "100",
        },
        {
          title: "Email",
          dataIndex: "email",
          key: "email",
          width: "130",
        },
      ],
    },
    {
      title: "User Groups",
      width: "210",
      children: [
        {
          title: "Initiator User Group",
          dataIndex: "initiatorUserGroup",
          key: "initiatorUserGroup",
          width: "68",
        },
        {
          title: "Reviewer User Group",
          dataIndex: "reviewerUserGroup",
          key: "reviewerUserGroup",
          width: "68",
        },
        {
          title: "Approval User Group",
          dataIndex: "approvalUserGroup",
          key: "approvalUserGroup",
          width: "68",
        },
      ],
    },
  ];

  for (let i = 1; i <= 100; i++) {
    const row = {
      id: i,
      firstName: `Tope`,
      lastName: `Ayinde`,
      phoneNumber: `09088667755`,
      email: `JokeSilva@MOE.com`,
      initiatorUserGroup: `N/A`,
      reviewerUserGroup: `N/A`,
      approvalUserGroup: `N/A`,
    };
    dataSource.push(row);
  }

  function checkFirstNamePresent(
    firstName: any,
    fullNameArray: string | any[]
  ) {
    for (let i = 0; i < fullNameArray?.length; i++) {
      const fullName = fullNameArray[i];
      const spaceIndex = fullName.indexOf(" ");
      const extractedFirstName = fullName.substring(0, spaceIndex);

      if (extractedFirstName === firstName) {
        return true;
      }
    }

    return false;
  }

  const goBacktoTable = () => {
    navigate("/admin/mda-directory");
  };

  const activateOrg = () => {
    const currentPath = window.location.pathname;
    const lastSlashIndex = currentPath.lastIndexOf("/");

    if (lastSlashIndex !== -1) {
      const lastSegment = currentPath.substring(lastSlashIndex + 1);

      setServiceId(lastSegment);

      console.log(lastSegment);

      activateMutate(lastSegment, {
        onSuccess: (response: any) => {
          setConfirmationModal(false);
          setSuccessModal(true);
        },
        onError: (err: any) => {
          ErrorToast(err);
          navigate("/admin/mda-directory");
        },
      });
    } else {
      navigate("/admin/mda-directory");
    }
  };

  //   const formatMoney = (value: number): string => {
  //     const suffixes = ['', 'K', 'M', 'B', 'T', 'Q'];
  //     const suffixNum = Math.floor(('' + value).length / 4);

  //     let formattedValue = parseFloat((suffixNum !== 0 ? (value / Math.pow(1000, suffixNum)) : value).toFixed(2));
  //     if (formattedValue % 1 !== 0) {
  //       formattedValue = parseFloat(formattedValue.toFixed(1));
  //     }

  //     return `₦ ${formattedValue.toLocaleString()}${suffixes[suffixNum]}`;
  //   };

  return (
    <>
      <>
        {isLoading || activateLoading ? (
          <div className="loading-container">
            <FlapperSpinner /> {/* Replace with your loading indicator */}
          </div>
        ) : (
          <>
            <div className={"mdaDetailsPage"}>
              <div className={"mdaDetailsBreadcrumb"}>
                <div className="cursor-pointer" onClick={goBacktoTable}>
                  <img src={goBack} alt=" " />
                </div>

                <div>organization Reviewer</div>

                <svg
                  width="10"
                  height="12"
                  viewBox="0 0 10 12"
                  fill="none"
                  xmlns="http://www.w3.Entity/2000/svg"
                >
                  <path
                    d="M0 1.0744L0 10.9256C0 11.3254 0.236844 11.692 0.613658 11.8774C0.991157 12.0628 1.44706 12.0363 1.79669 11.8087L9.55942 6.75661C9.83645 6.57665 10.0007 6.28017 10 5.96438C9.99858 5.64825 9.83207 5.35271 9.55431 5.1742L1.79158 0.18791C1.44044 -0.0373831 0.986688 -0.0618248 0.610557 0.123958C0.235339 0.309997 0 0.675697 0 1.0744Z"
                    fill="black"
                    fill-opacity="0.5"
                  />
                </svg>

                <div>organization Details</div>
              </div>

              <div className={"mdaDetailsRow1"}>
                <div>Profile Creator Details</div>

                <div>
                  <div className="my-2">
                    <div>First Name</div>
                    <div>{detailsData?.admin?.firstName}</div>
                  </div>

                  <div className="my-2">
                    <div>Last Name</div>
                    <div>{detailsData?.admin?.lastName}</div>
                  </div>

                  <div className="my-2">
                    <div>Phone Number</div>
                    <div>{detailsData?.admin?.phoneNumber}</div>
                  </div>

                  <div className="my-2">
                    <div>Email</div>
                    <div>{detailsData?.admin?.email}</div>
                  </div>

                  <div className="my-2">
                    <div>Institution</div>
                    <div>{detailsData?.admin?.organizationName}</div>
                  </div>
                </div>
              </div>

              <div className={"mdaDetailsRow2"}>
                <div>Entity Details</div>

                <div>
                  <div className="my-2">
                    <div>Registered Entity Name</div>
                    <div> {detailsData?.organization?.registeredName}</div>
                  </div>

                  <div className="my-2">
                    <div>Entity Code</div>
                    <div>{detailsData?.organization?.mdaAdminCode}</div>
                  </div>

                  <div className="my-2">
                    <div>Trading Name</div>
                    <div>{detailsData?.organization?.tradingName}</div>
                  </div>

                  <div className="my-2">
                    <div>Entity Sector</div>
                    <div>{detailsData?.organization?.sector.code} </div>
                  </div>

                  <div className="my-2">
                    <div>Entity Physical Address</div>
                    <div>
                      {detailsData?.organization?.contact?.physicalAddress}
                    </div>
                  </div>

                  <div className="my-2">
                    <div>Entity Country</div>
                    <div>{detailsData?.organization?.contact?.country}</div>
                  </div>

                  <div className="my-2">
                    <div>Entity State/Province</div>
                    <div>{detailsData?.organization?.contact?.state}</div>
                  </div>

                  <div className="my-2">
                    <div>Entity City/Region</div>
                    <div>{detailsData?.organization?.contact?.city}</div>
                  </div>

                  <div className="my-2">
                    <div>Entity Phone Number</div>
                    <div>{detailsData?.organization?.contact?.phoneNumber}</div>
                  </div>

                  <div className="my-2">
                    <div>Entity Email Address</div>
                    <div>{detailsData?.organization?.contact?.email}</div>
                  </div>

                  <div className="my-2">
                    <div>Website URL</div>
                    <div>{detailsData?.organization?.contact?.websiteUrl}</div>
                  </div>

                  <div className="my-2">
                    <div>Twitter Handle</div>

                    <div>
                      {detailsData?.organization?.contact?.twitterHandle}
                    </div>
                  </div>
                </div>
              </div>

              <div className={"mdaDetailsRow3 "}>
                <div>Bank Account Details</div>

                <div className="table-responsive mx-0 px-0 w-100">
                  <table className="table align-middle  gx-0 gy-1 mt-1">
                    <thead className="bg-white">
                      <tr>
                        <th className="min-w-200px text-start text-black fs-8 bg-white border-0 fw-bolder">
                          Bank Account Number
                        </th>
                        <th className="min-w-200px text-start text-black fs-8 bg-white border-0 fw-bolder">
                          Bank Name
                        </th>
                        {/* <th className="min-w-200px text-start text-black fs-8 bg-white border-0 fw-bolder">
                          Account Classification
                        </th> */}

                        <th className="min-w-150px text-start text-black fs-8 bg-white border-0 fw-bolder">
                          Account Name
                        </th>

                        <th className="min-w-150px text-start text-black fs-8 bg-white border-0 fw-bolder">
                          Daily Transaction Limit
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {detailsData?.bankDetails?.map(
                        (array: any, index: any) => {
                          //   console.log("ddd", array);
                          return (
                            <tr key={index}>
                              <td className="text-dark fs-9  text-start border-0 capitaliseText">
                                {array.accountNumber}
                              </td>
                              <td className="text-dark fs-9  text-start capitaliseText border-0">
                                {array.bankName}
                              </td>
                              {/* <td className="text-dark fs-9  text-center border-0">
                                {array.accountType.description}
                              </td> */}
                              <td className="text-dark fs-9  text-start capitaliseText border-0">
                                {array.accountName}
                              </td>
                              <td className="text-dark fs-9  text-start border-0">
                                {FormatMoney(array.dailyLimit)}
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>

                {/* <div>
                  <div>
                    <div>Bank Account Number</div>
                    <div>0069185929</div>
                  </div>

                  <div>
                    <div>Bank Name</div>
                    <div>Central Bank of Nigeria (CBN)</div>
                  </div>

                  <div>
                    <div>Account Classification</div>
                    <div>Federation Account</div>
                  </div>

                  <div>
                    <div>Account Name</div>
                    <div>Federal Ministry of Agriculture</div>
                  </div>

                  <div>
                    <div>Daily Transaction Limit</div>
                    <div>NGN 5,000,000,000</div>
                  </div>
                </div> */}
              </div>

              <div className={"mdaDetailsRow4"}>
                <div>User Groups & Approval Workflow Definition</div>

                {detailsData?.workflows?.map((item: any, index: any) => {
                  var data: any = [];

                  var initiator = item.roles.find(
                    (obj: { name: string }) => obj.name === "initiator"
                  );
                  var reviewer = item.roles.find(
                    (obj: { name: string }) => obj.name === "reviewer"
                  );
                  var approver = item.roles.find(
                    (obj: { name: string }) => obj.name === "approver"
                  );

                  for (let i = 0; i <= detailsData?.users?.length - 1; i++) {
                    const row = {
                      id: i + 1,
                      firstName: detailsData?.users[i]?.firstName,
                      lastName: detailsData?.users[i]?.lastName,
                      phoneNumber: detailsData?.users[i]?.phoneNumber,
                      email: detailsData?.users[i]?.email,
                      initiatorUserGroup: checkFirstNamePresent(
                        detailsData?.users[i]?.firstName,
                        initiator?.users
                      ) ? (
                        <img src={DoubleCheck} alt=" " />
                      ) : (
                        `N/A`
                      ),
                      reviewerUserGroup: checkFirstNamePresent(
                        detailsData?.users[i]?.firstName,
                        reviewer?.users
                      ) ? (
                        <img src={DoubleCheck} alt=" " />
                      ) : (
                        `N/A`
                      ),
                      approvalUserGroup: checkFirstNamePresent(
                        detailsData?.users[i]?.firstName,
                        approver?.users
                      ) ? (
                        <img src={DoubleCheck} alt=" " />
                      ) : (
                        `N/A`
                      ),
                    };
                    data.push(row);
                  }

                  return (
                    <div className={"processTypeTables"} key={index}>
                      <div>
                        <span className=""> Process Type : </span>
                        <span className=""> {item.cat} </span>
                      </div>

                      <div style={{ overflowX: "auto" }}>
                        <Table
                          dataSource={data}
                          bordered
                          columns={columns}
                          // scroll={{ x: "970px" }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className={"mdaDetailsRow5"}>
                <div>
                  {!detailsData?.organization?.active ? (
                    <button className=" btn btn-danger">Reject</button>
                  ) : (
                    <button
                      className="btn rounded-1  center-all mx-5 bg-white rounded-1 border-success "
                      type="button"
                      onClick={() => goBacktoTable()}
                    >
                      <span className="fs-5 text-success ">Back</span>
                    </button>
                  )}
                </div>

                <div>
                  <button
                    onClick={() => setConfirmationModal(true)}
                    className={`btn ${
                      !detailsData?.organization?.active
                        ? " btn-success "
                        : " btn-danger "
                    } rounded-1 w-220 h-51 center-all mx-5  border-0`}
                  >
                    {!detailsData?.organization?.active
                      ? "Approve"
                      : "Deactivate"}
                  </button>
                </div>
              </div>

              <Modal
                centered
                style={{ width: "500px", maxWidth: "100%" }}
                open={confirmationModal}
                onOk={() => setConfirmationModal(false)}
                onCancel={() => setConfirmationModal(false)}
                footer={null}
              >
                <div className={"rvpConfirmationModal"}>
                  <svg
                    style={{ justifySelf: "center" }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.Entity/2000/svg"
                  >
                    <path
                      d="M11.2499 13.8755C11.2499 14.2897 11.5857 14.6255 11.9999 14.6255C12.4142 14.6255 12.7499 14.2897 12.7499 13.8755H11.2499ZM11.9999 12.938V12.188C11.801 12.188 11.6103 12.267 11.4696 12.4077C11.329 12.5483 11.2499 12.7391 11.2499 12.938H11.9999ZM7.96869 9.65678C7.96869 10.071 8.30448 10.4068 8.71869 10.4068C9.1329 10.4068 9.46869 10.071 9.46869 9.65678H7.96869ZM22.5 12C22.5 17.799 17.799 22.5 12 22.5V24C18.6274 24 24 18.6274 24 12H22.5ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12H0C0 18.6274 5.37258 24 12 24V22.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V0C5.37258 0 0 5.37258 0 12H1.5ZM12 1.5C17.799 1.5 22.5 6.20101 22.5 12H24C24 5.37258 18.6274 0 12 0V1.5ZM12.6562 18.0938C12.6562 18.4562 12.3624 18.75 12 18.75V20.25C13.1909 20.25 14.1562 19.2846 14.1562 18.0938H12.6562ZM12 18.75C11.6376 18.75 11.3438 18.4562 11.3438 18.0938H9.84375C9.84375 19.2846 10.8091 20.25 12 20.25V18.75ZM11.3438 18.0938C11.3438 17.7313 11.6376 17.4375 12 17.4375V15.9375C10.8091 15.9375 9.84375 16.9029 9.84375 18.0938H11.3438ZM12 17.4375C12.3624 17.4375 12.6562 17.7313 12.6562 18.0938H14.1562C14.1562 16.9029 13.1909 15.9375 12 15.9375V17.4375ZM12.7499 13.8755V12.938H11.2499V13.8755H12.7499ZM11.9999 13.688C12.7972 13.688 13.5766 13.4516 14.2396 13.0086L13.4062 11.7614C12.99 12.0396 12.5006 12.188 11.9999 12.188L11.9999 13.688ZM14.2396 13.0086C14.9025 12.5657 15.4192 11.9361 15.7243 11.1995L14.3385 10.6254C14.1469 11.088 13.8225 11.4833 13.4062 11.7614L14.2396 13.0086ZM15.7243 11.1995C16.0294 10.4629 16.1093 9.6523 15.9537 8.87032L14.4826 9.16295C14.5802 9.65397 14.5301 10.1629 14.3385 10.6254L15.7243 11.1995ZM15.9537 8.87032C15.7982 8.08833 15.4142 7.37003 14.8505 6.80625L13.7898 7.86691C14.1438 8.22091 14.3849 8.67194 14.4826 9.16295L15.9537 8.87032ZM14.8505 6.80625C14.2867 6.24247 13.5684 5.85853 12.7864 5.70299L12.4938 7.17416C12.9848 7.27183 13.4358 7.51291 13.7898 7.86691L14.8505 6.80625ZM12.7864 5.70299C12.0044 5.54744 11.1939 5.62727 10.4572 5.93239L11.0313 7.31821C11.4938 7.12662 12.0027 7.0765 12.4938 7.17416L12.7864 5.70299ZM10.4572 5.93239C9.72063 6.2375 9.09104 6.7542 8.64808 7.41713L9.89528 8.25049C10.1734 7.83423 10.5687 7.50979 11.0313 7.31821L10.4572 5.93239ZM8.64808 7.41713C8.20512 8.08007 7.96869 8.85947 7.96869 9.65678H9.46869C9.46869 9.15614 9.61715 8.66675 9.89528 8.25049L8.64808 7.41713Z"
                      fill="#61CD85"
                    />
                  </svg>

                  {/*<div className={'rdFilterModalRow1'}>*/}
                  <div className={"rvpConfirmationModalTitle"}>
                    Confirmation
                  </div>
                  {/*</div>*/}

                  <div style={{ justifySelf: "center" }}>
                    Please confirm you want to proceed with this request
                  </div>

                  <div className={"rvpConfirmationModalActionButton"}>
                    <button
                      className="btn btn-outline-success px-7 py-2 h-44 w-200 rounded-1"
                      onClick={() => setConfirmationModal(false)}
                    >
                      <span className="indicator-label fs-base">Cancel</span>
                    </button>

                    <button
                      // onClick={() => submitPayment()}
                      onClick={() => {
                        activateOrg();
                      }}
                      className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                    >
                      <span className="indicator-label fs-base text-White">
                        Proceed
                      </span>
                    </button>
                  </div>
                </div>
              </Modal>

              <Modal
                centered
                style={{ width: "500px", maxWidth: "100%" }}
                open={successModal}
                onOk={() => setSuccessModal(false)}
                onCancel={() => setSuccessModal(false)}
                footer={null}
              >
                <div className={"rvpConfirmationModal"}>
                  <svg
                    style={{ justifySelf: "center" }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.Entity/2000/svg"
                  >
                    <path
                      d="M17.1562 9.1875L10.2812 15.75L6.84375 12.4688M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                      stroke="#61CD85"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <div className={"rvpConfirmationModalTitle"}>Successful!</div>

                  <div style={{ textAlign: "center" }}>
                    {detailsData?.organization?.active
                      ? "Organization has been deactivated"
                      : "Organization has been activated, and each organization user has received an email notifying them of the activation"}
                  </div>

                  <div className={"rvpConfirmationModalActionButton"}>
                    <button
                      className="btn btn-success px-7 py-2 h-44 w-150 rounded-1 "
                      onClick={() => {
                        setSuccessModal(false);
                        navigate("/admin/mda-directory");
                      }}
                    >
                      <span className="indicator-label fs-base text-White">
                        Ok
                      </span>
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
          </>
        )}
      </>
    </>
  );
};

export default MdaDetails;
